import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IPickMutation } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient, queryClient } from "../../clients";

import type { IMemberWorkingExperience } from "./routeType";
import { useGetAllMemberWorkingExperiences } from "./getAll";

const { getPath } = getApi("members.workingExperience.post");

type IExtractedRouteType =
  IMemberWorkingExperience["workingExperienceSingleCreate"];

export type IPostMemberWorkingExperience = IPickMutation<IExtractedRouteType>;

const postMemberWorkingExperience: MutationFunction<
  IPostMemberWorkingExperience["response"],
  IPostMemberWorkingExperience["variables"]
> = ({ memberId, ...data }) => {
  return axiosClient.post(getPath({ memberId }), data);
};

export const usePostMemberWorkingExperience = createMutation({
  mutationFn: postMemberWorkingExperience,
  onSuccess: () => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberWorkingExperiences.getKey(),
    });
  },
});
